export default "<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"migrate()\" [disabled]=\"isWorking\">Migrar archivos</button>"